/**
 * [Feature Toggles](https://martinfowler.com/articles/feature-toggles.html)
 * are a powerful technique, allowing teams to modify system behavior without changing code.
 *
 * For more info, see https://chalk.charter.com/display/ERSPM/FE+Configs.
 */

/**
 * FEATURE TOGGLE NAMES ENUM is used to keep track of all names used in the app
 * to avoid duplicates as well as eliminate possible spelling issues.
 *
 * The Feature Toggle naming convention is as follows:
 *
 * DomainPageFeature
 *
 * If the DOMAIN doesn't apply, use 'Misc' for the Miscellaneous Toggles group.
 * The PAGE may not apply, but if it does include it in the name.
 */
export enum FeatureToggleName {
  SSOPortalLinks = 'SSOPortalLinks',
  SSOPortalLinksOrgTable = 'SSOPortalLinksOrgTable',
  TVP = 'TVP',
  AnalyticsQuantum = 'AnalyticsQuantum',
  PrefetchData = 'PrefetchData',
  DataDogRumIntegration = 'DataDogRumIntegration',
  UserVDSManagement = 'UserVDSManagement',
  PendingUsers = 'PendingUsers',
  BanNotificationSetting = 'BanNotificationSetting',
  // Gates the new PAM Ops Center "Add New Customer User" flow. Enabled in every
  // environment; the legacy flow is the fallback when off. See ENTDEL-29414.
  PAM = 'PAM',
  OrgDetailsProgressiveDelivery = 'OrgDetailsProgressiveDelivery',
}

export interface IFeatureToggle {
  readonly name: FeatureToggleName;
  readonly isEnabled: boolean;
}

export interface IFeatureToggles {
  readonly environment: string;
  readonly toggles: IFeatureToggle[];
}

export type IFlatFeatureToggles = {
  [key in FeatureToggleName]: boolean;
};
